enum LangType {
  zh = 'CN',
  en = 'EN',
  pt = 'PT-BR'
}
export default LangType
